import React from "react";
import { Row } from "react-bootstrap";
import { IPdfContent } from "@domains/aggregates/interfaces/iFooterPages";
import PdfCard from "../../../Common/PdfCard";

const PoliciesAndCodes = (props: { pdfContent: Array<IPdfContent> }) => {
  return (
    <Row className="policy-code pdf-box m-0">
      <PdfCard pdfList={props.pdfContent} />
    </Row>
  );
};

export default PoliciesAndCodes;
